import * as tslib_1 from "tslib";
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';
import { AppStateFacade } from '@app-state';
import { UiExecutionSettingsComponent, UiModalComponent, } from '@components';
import { CredentialStoreGenericType, CredentialStoreResourceType, FeatureFlag, RobotHostingType, RobotState, RobotType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { CredentialStoresService, ResourceMapperService, RobotService, SettingService, SignalRService, } from '@services';
import { resolveUnionTypeByProperty } from '@utils/type.utils';
import UiValidators, { UI_ROBOT_DESCRIPTION_MAX_LENGTH, UI_ROBOT_NAME_MAX_LENGTH, UI_ROBOT_PASSWORD_MAX_LENGTH, UI_ROBOT_USERNAME_MAX_LENGTH, UI_ROBOT_USERNAME_REGEX, } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, forkJoin, Subject, } from 'rxjs';
import { filter, finalize, startWith, takeUntil, } from 'rxjs/operators';
export var RobotFormControl;
(function (RobotFormControl) {
    RobotFormControl["hostingType"] = "hostingType";
    RobotFormControl["machine"] = "machine";
    RobotFormControl["name"] = "name";
    RobotFormControl["type"] = "type";
    RobotFormControl["description"] = "description";
    RobotFormControl["robotCredentials"] = "robotCredentials";
    RobotFormControl["username"] = "userName";
    RobotFormControl["executionSettings"] = "executionSettings";
    RobotFormControl["isExternalLicense"] = "isExternalLicense";
})(RobotFormControl || (RobotFormControl = {}));
export var RobotCredentialsControl;
(function (RobotCredentialsControl) {
    RobotCredentialsControl["credentialStore"] = "credentialStore";
    RobotCredentialsControl["credentialStoreConfig"] = "credentialStoreConfig";
    RobotCredentialsControl["isCredentialSmartCard"] = "isCredentialSmartCard";
})(RobotCredentialsControl || (RobotCredentialsControl = {}));
export var CredentialStoreConfigControl;
(function (CredentialStoreConfigControl) {
    CredentialStoreConfigControl["password"] = "password";
    CredentialStoreConfigControl["externalName"] = "externalName";
})(CredentialStoreConfigControl || (CredentialStoreConfigControl = {}));
var PASSWORD_CONTROL = function (robot) { return new FormControl(robot.password, Validators.maxLength(UI_ROBOT_PASSWORD_MAX_LENGTH)); };
var ɵ0 = PASSWORD_CONTROL;
var EXTERNAL_NAME_CONTROL = function (robot) { return new FormControl(robot.externalName); };
var ɵ1 = EXTERNAL_NAME_CONTROL;
var RobotModalBaseComponent = /** @class */ (function (_super) {
    tslib_1.__extends(RobotModalBaseComponent, _super);
    function RobotModalBaseComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.executionSettingsValues = cloneDeep(_this.context.data.executionSettings) || {};
        _this.robotTypeDropdownEntries = [];
        _this.createAnother = false;
        _this.credentialStoreDropdownEntries = [];
        _this.RobotFormControl = RobotFormControl;
        _this.RobotCredentialsControl = RobotCredentialsControl;
        _this.CredentialStoreConfigControl = CredentialStoreConfigControl;
        _this.RobotType = RobotType;
        _this.CredentialStoreGenericType = CredentialStoreGenericType;
        _this.submitting$ = new BehaviorSubject(false);
        _this.loadingData$ = new BehaviorSubject(true);
        _this.refocusField$ = new BehaviorSubject(false);
        _this.executionSettingsConfig$ = new BehaviorSubject([]);
        _this.isRobotBusy$ = new BehaviorSubject(false);
        _this._robotService = _this._injector.get(RobotService);
        _this._credentialService = _this._injector.get(CredentialStoresService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._settingsService = _this._injector.get(SettingService);
        _this._signalRService = _this._injector.get(SignalRService);
        _this._formBuilder = _this._injector.get(FormBuilder);
        _this._liveAnnouncer = _this._injector.get(LiveAnnouncer);
        _this._appState = _this._injector.get(AppStateFacade);
        _this._destroyed$ = new Subject();
        _this._robotTypeToDropdownEntry = function (type) { return ({
            id: type,
            text: _this._translateService.instant(ResourceMapperService.robotType[RobotType[type]]),
        }); };
        _this._credentialStoreToDropdownEntry = function (credentialStore) { return ({
            id: credentialStore.id,
            text: credentialStore.name,
            data: credentialStore,
        }); };
        return _this;
    }
    Object.defineProperty(RobotModalBaseComponent.prototype, "executionSettingsComponent", {
        set: function (value) {
            if (!value ||
                !!this.robotForm.get(RobotFormControl.executionSettings)) {
                return;
            }
            this._executionSettingsComponent = value;
            this.robotForm.addControl(RobotFormControl.executionSettings, value.formGroup);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "robotTypes", {
        get: function () {
            return this._robotService.getRobotTypes(this.hostingType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "defaultRobotType", {
        get: function () {
            return this.context.data.type == null ? RobotType.Development : this.context.data.type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "selectedRobotType", {
        get: function () {
            var selectedDropdownEntry = this.robotForm.get(RobotFormControl.type).value[0];
            return selectedDropdownEntry.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "selectedCredentialStore", {
        get: function () {
            var selectedDropdownEntry = this.robotCredentialsForm.get(RobotCredentialsControl.credentialStore).value[0];
            return selectedDropdownEntry ? selectedDropdownEntry.data : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "credentialStoreConfigForm", {
        get: function () {
            return this.robotCredentialsForm.get(RobotCredentialsControl.credentialStoreConfig);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "isSmartCardAuthFeatureEnabled", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.SmartCardAuth);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "isSubmitDisabled", {
        get: function () {
            return this.loadingData$.getValue() ||
                this.robotForm.invalid ||
                this.submitting$.getValue();
        },
        enumerable: true,
        configurable: true
    });
    RobotModalBaseComponent.prototype.ngOnInit = function () {
        var _a;
        var _this = this;
        if (this.context.isDuplicate) {
            this.context.data = tslib_1.__assign({}, this.context.data, { id: NaN, name: '', description: '', userName: '', password: '', externalName: '' });
        }
        this.robotForm = this._formBuilder.group(this._robotFormConfig);
        this.robotCredentialsForm = this._formBuilder.group(this._robotCredentialsFormConfig);
        this.robotForm.addControl(RobotFormControl.robotCredentials, this.robotCredentialsForm);
        this.credentialStoreConfigControls = (_a = {},
            _a[CredentialStoreConfigControl.password] = PASSWORD_CONTROL(this.context.data),
            _a[CredentialStoreConfigControl.externalName] = EXTERNAL_NAME_CONTROL(this.context.data),
            _a);
        this.robotTypeDropdownEntries = this.robotTypes
            .map(this._robotTypeToDropdownEntry);
        this.robotForm
            .get(RobotFormControl.type)
            .valueChanges
            .pipe(startWith([this._robotTypeToDropdownEntry(this.defaultRobotType)]), takeUntil(this._destroyed$))
            .subscribe(function (value) {
            var selected = value[0];
            _this._onRobotTypeChange(selected.id);
        });
        this.robotCredentialsForm
            .get(RobotCredentialsControl.credentialStore)
            .valueChanges
            .pipe(takeUntil(this._destroyed$))
            .subscribe(function (value) {
            var selected = value[0];
            selected ?
                _this._onCredentialStoreTypeChange(selected.data.type.genericType, selected.data.details.isReadOnly) :
                _this._onCredentialStoreTypeChange();
        });
        forkJoin({
            settings: this._settingsService.getExecutionSettingsConfiguration(1 /* Robot */),
            credentialStores: this._credentialService.get(),
            defaultCredentialStoreId: this._credentialService.getDefaultStore(CredentialStoreResourceType.RobotCredential),
        })
            .pipe(finalize(function () { return _this.loadingData$.next(false); }))
            .subscribe(function (_a) {
            var settings = _a.settings, credentialStores = _a.credentialStores, defaultCredentialStoreId = _a.defaultCredentialStoreId;
            _this.executionSettingsConfig$.next(settings.configuration);
            _this.credentialStoreDropdownEntries = credentialStores.data.map(_this._credentialStoreToDropdownEntry);
            var defaultCredentialStore = credentialStores.data.find(function (store) {
                return store.id === (_this.context.data.credentialStoreId || defaultCredentialStoreId);
            });
            _this.robotCredentialsForm
                .get(RobotCredentialsControl.credentialStore)
                .setValue(defaultCredentialStore
                ? [_this._credentialStoreToDropdownEntry(defaultCredentialStore)]
                : []);
        });
        if (!this.context.isNewEntry) {
            this._subscribeToSessionUpdates();
        }
        this._announceFormInfo();
    };
    RobotModalBaseComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    RobotModalBaseComponent.prototype.resetPassword = function () {
        this.credentialStoreConfigControls[CredentialStoreConfigControl.password]
            .reset();
    };
    RobotModalBaseComponent.prototype.onCredentialSmartCardChange = function () {
        if (!this.context.isNewEntry) {
            this.resetPassword();
        }
    };
    RobotModalBaseComponent.prototype.onSubmit = function () {
        if (this.isSubmitDisabled) {
            return;
        }
        this.submitting$.next(true);
        var payload = this._formValueToPayload(this.robotForm.value);
        if (this.context.isNewEntry) {
            this._addRobot(payload);
        }
        else {
            this._updateRobot(payload);
        }
    };
    RobotModalBaseComponent.prototype._addRobot = function (payload) {
        var _this = this;
        this.refocusField$.next(false);
        this._robotService.add(payload)
            .pipe(finalize(function () {
            _this.submitting$.next(false);
        })).subscribe(function (response) {
            if (!_this.createAnother) {
                _this._dialogRef.close({
                    type: 1 /* Add */,
                });
            }
            else {
                _this.customEvent.emit({
                    type: 1 /* Add */,
                });
                _this.robotForm.reset(_this._getFormValueToCreateAnother(response));
                _this._executionSettingsComponent.resetSettings();
                _this.refocusField$.next(true);
            }
        });
    };
    RobotModalBaseComponent.prototype._updateRobot = function (payload) {
        var _this = this;
        var robotId = this.context.data.id;
        payload.id = robotId;
        this._robotService.update(robotId, payload)
            .pipe(finalize(function () { return _this.submitting$.next(false); }))
            .subscribe(function () {
            _this._dialogRef.close({
                type: 2 /* Update */,
                data: tslib_1.__assign({}, payload, { password: null, executionSettings: null }),
            });
        });
    };
    RobotModalBaseComponent.prototype._formValueToPayload = function (_a) {
        var robotCredentials = _a.robotCredentials, type = _a.type, machine = _a.machine, rest = tslib_1.__rest(_a, ["robotCredentials", "type", "machine"]);
        var isExternalLicenseApplicable = [RobotType.Development, RobotType.StudioX].includes(this.selectedRobotType);
        rest[RobotFormControl.isExternalLicense] =
            isExternalLicenseApplicable
                ? !!rest[RobotFormControl.isExternalLicense]
                : false;
        var credentials = robotCredentials ? tslib_1.__assign({ credentialStoreId: this.selectedCredentialStore.id }, (this.isSmartCardAuthFeatureEnabled ? {
            isCredentialSmartCard: robotCredentials.isCredentialSmartCard,
        } : {}), robotCredentials.credentialStoreConfig) : {};
        return tslib_1.__assign({ type: this.selectedRobotType }, credentials, rest);
    };
    Object.defineProperty(RobotModalBaseComponent.prototype, "_robotFormConfig", {
        get: function () {
            var _a;
            return _a = {},
                _a[RobotFormControl.hostingType] = [
                    this.hostingType,
                ],
                _a[RobotFormControl.name] = [
                    this.context.data.name,
                    Validators.compose([
                        UiValidators.required(),
                        Validators.maxLength(UI_ROBOT_NAME_MAX_LENGTH),
                    ]),
                ],
                _a[RobotFormControl.type] = [
                    [this._robotTypeToDropdownEntry(this.defaultRobotType)],
                ],
                _a[RobotFormControl.username] = [
                    this.context.data.userName,
                    Validators.compose([
                        UiValidators.required(),
                        Validators.maxLength(UI_ROBOT_USERNAME_MAX_LENGTH)
                    ].concat((this.hostingType === RobotHostingType.Floating ? [UiValidators.regex(UI_ROBOT_USERNAME_REGEX)] : []))),
                ],
                _a[RobotFormControl.description] = [
                    this.context.data.description,
                    Validators.maxLength(UI_ROBOT_DESCRIPTION_MAX_LENGTH),
                ],
                _a[RobotFormControl.isExternalLicense] = [
                    !!this.context.data.isExternalLicense,
                ],
                _a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RobotModalBaseComponent.prototype, "_robotCredentialsFormConfig", {
        get: function () {
            var _a, _b;
            return tslib_1.__assign((_a = {}, _a[RobotCredentialsControl.credentialStore] = [
                [],
                Validators.required,
            ], _a), (this.isSmartCardAuthFeatureEnabled ? (_b = {},
                _b[RobotCredentialsControl.isCredentialSmartCard] = [
                    this.context.data.isCredentialSmartCard,
                ],
                _b) : {}));
        },
        enumerable: true,
        configurable: true
    });
    RobotModalBaseComponent.prototype._onRobotTypeChange = function (type) {
        type === RobotType.Attended ?
            this.robotForm.removeControl(RobotFormControl.robotCredentials) :
            this.robotForm.addControl(RobotFormControl.robotCredentials, this.robotCredentialsForm);
    };
    RobotModalBaseComponent.prototype._onCredentialStoreTypeChange = function (type, isReadOnly) {
        if (isReadOnly === void 0) { isReadOnly = false; }
        this.robotCredentialsForm.removeControl(RobotCredentialsControl.credentialStoreConfig);
        this.robotCredentialsForm.addControl(RobotCredentialsControl.credentialStoreConfig, new FormGroup({}));
        if (type == null) {
            // mark the field visually according to its validators
            var credentialStoreControl = this.robotCredentialsForm.get(RobotCredentialsControl.credentialStore);
            credentialStoreControl.markAsTouched();
            return;
        }
        var credentialStoreConfig = this.robotCredentialsForm.get(RobotCredentialsControl.credentialStoreConfig);
        if (!isReadOnly) {
            credentialStoreConfig.addControl(CredentialStoreConfigControl.password, this.credentialStoreConfigControls.password);
        }
        if (type === CredentialStoreGenericType.SecureStore) {
            credentialStoreConfig.addControl(CredentialStoreConfigControl.externalName, this.credentialStoreConfigControls.externalName);
        }
    };
    RobotModalBaseComponent.prototype._announceFormInfo = function () {
        if (this.context.isNewEntry) {
            this._liveAnnouncer.announce(this.formTitle + ' ' + this.formDescription);
        }
    };
    RobotModalBaseComponent.prototype._subscribeToSessionUpdates = function () {
        var _this = this;
        this._signalRService.sessions$
            .pipe(startWith(this.context.additionalData.model), filter(function (session) { return (resolveUnionTypeByProperty(session, 'robotId') ?
            session.robotId :
            session.robot.id) === _this.context.data.id; }), takeUntil(this._destroyed$))
            .subscribe(function (session) { return _this.isRobotBusy$.next(session.state === RobotState[RobotState.Busy]); });
    };
    return RobotModalBaseComponent;
}(UiModalComponent));
export { RobotModalBaseComponent };
export { ɵ0, ɵ1 };
